import "App/routing/combineRoutesMap";
export { history, default as store } from "./store";
